import React, { useState, useEffect } from 'react'
import { Panel } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import BackgroundOfRiskPointsForm from './BackgroundOfRiskPointsForm'
import BackgroundOfRiskPointsView from './BackgroundOfRiskPointsView'
import { useForm, Controller } from 'react-hook-form'
import { useDispatch } from 'react-redux'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { startLoading, doneLoading } from '../../../../utils/loading'
import { getSchemaSidebar } from '../../../../redux/actions/sidebar'
import { updateForm6, saveForm6, downloadFileForm6 } from '../../../../redux/actions/background'
import ButtonPanel from '../../../ButtonPanel'
import WhisperMoreContent from '../../../WhisperMoreContent'
import WarningMessage from '../../../../components/message/WarningMessage/WarningMessage'

export default function BackgroundOfRiskPointsWidget(props) {
  const { showCommandButton, schema, isEdit, onChangeIsEdit } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  // const [formSchema, setFormSchema] = useState(formSchemas)
  const [formSchema, setFormSchema] = useState(schema)

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [moreContent, setMoreContent] = useState(true)
  const [moreContentBottom, setMoreContentBottom] = useState(true)

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response
      if (request.id) {
        console.log('call update.')
        response = await updateForm6(projectId, request)
      } else {
        console.log('call save.')
        response = await saveForm6(projectId, request)
      }
      // console.log('response', response)
      if (response) {
        onChangeIsEdit(false)
        setFormSchema(response)
        await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onDownloadFile = async (fileId, fileName) => {
    startLoading()
    var file = await downloadFileForm6(projectId, fileId)

    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)

    const request = {
      id: formSchema.id,
      projectVersionId: projectId,
      communityInfo: data.communityInfo || '-ไม่ระบุ-',
      accidentRiskPoint: data.accidentRiskPoint || 0,
      accidentLocaltions: data.frequentAccidentsPointList,
      loss: data.loss,
    }

    // console.log('request', request)
    // console.log('request', JSON.stringify(request))
    handleCallService(request)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
    >
      <WarningMessage style={{ marginTop: -10 }} message={formSchema?.feedbackBySubject} />

      {moreContent && (
        <>
          <div dangerouslySetInnerHTML={{ __html: formSchema.introduction }} />
        </>
      )}

      {formSchema.introduction && (
        <div style={{ textAlign: 'center', marginTop: '10px' }}>
          <WhisperMoreContent
            isShow={moreContent}
            onClick={() => {
              setMoreContent(!moreContent)
            }}
          />
        </div>
      )}

      {isEdit && showCommandButton ? (
        <BackgroundOfRiskPointsForm
          schema={formSchema}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
          getValues={getValues}
        />
      ) : (
        <BackgroundOfRiskPointsView schema={formSchema} onDownload={onDownloadFile} />
      )}

      <div style={{ textAlign: 'center' }}>
        <WhisperMoreContent
          isShow={moreContentBottom}
          onClick={() => {
            setMoreContentBottom(!moreContentBottom)
          }}
        />
      </div>

      {moreContentBottom && (
        <div
          dangerouslySetInnerHTML={{
            __html: formSchema.footer
              .replaceAll('{village}', formSchema.villageInfo.village || '-ไม่ระบุ-')
              .replaceAll('{subDistrict}', formSchema.villageInfo.subDistrict || '-ไม่ระบุ-')
              .replaceAll('{district}', formSchema.villageInfo.district || '-ไม่ระบุ-')
              .replaceAll('{province}', formSchema.villageInfo.province || '-ไม่ระบุ-'),
          }}
        />
      )}

      {showCommandButton && (
        <>
          <hr />
          <ButtonPanel
            isDisabled={isLoading}
            isEdit={isEdit}
            isError={isError}
            buttonText={formSchema.buttonText || 'ความเป็นมาหลักการและเหตุผล'}
            onSave={handleSubmit(onSubmit)}
            onCancel={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
            }}
            onEdit={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
              scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
            }}
          />
        </>
      )}
    </Panel>
  )
}

// const formSchemas = {
//   header: 'ความเป็นมา / หลักการและเหตุผล / ความสำคัญของปัญหา (06 จุดเสี่ยง ปี 63)',
//   introduction:
//     '<p>\n  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;\n  ปัญหาอุบัติเหตุเป็นปัญหาที่ทั่วโลกให้ความสำคัญ\n  สมัชชาสหประชาชาติได้ประกาศเจตนารมณ์ในปฏิญญามอสโกให้ปี พ.ศ.2554 - 2563\n  เป็นทศวรรษแห่งความปลอดภัยทางถนน (Decade of Action for Road Safety)\n  ประเทศไทยในฐานะประเทศสมาชิก ได้ร่วมขับเคลื่อนวาระความปลอดภัยทางถนนของโลก\n  โดยมีมติคณะรัฐมนตรี วันที่ 29 มิถุนายน 2553 กำหนดให้ “ปี 2554 - 2563\n  เป็นทศวรรษแห่งความปลอดภัยทางถนน” โดยมีเป้าหมาย\n  เพื่อลดอัตราการเสียชีวิตจากอุบัติเหตุทางถนนของคนไทยลงครึ่งหนึ่ง หรือในอัตราที่ต่ำกว่า\n  10 คนต่อประชากรหนึ่งแสนคน\n  และเพื่อให้ทุกภาคส่วนมีทิศทางการดำเนินงานและการแก้ไขปัญหาอุบัติเหตุทางถนนประสบผลสำเร็จเป็นรูปธรรม\n  จึงกำหนดกรอบในการจัดทำแผนปฏิบัติการ 8 ประการ โดยมีมาตรการการแก้ไขปัญหาจุดเสี่ยงอันตราย\n  เป็นหนึ่งในแผนปฏิบัติการดังกล่าว\n</p>\n<p>\n  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;\n  จากข้อมูลสถานการณ์อุบัติเหตุทางถนนของประเทศไทยในปี พ.ศ. 2555 – 2559\n  ของสำนักงานนโยบายและแผนการขนส่งและจราจร กระทรวงคมนาคม มีจำนวนครั้งเพิ่มขึ้น\n  แต่จำนวนผู้เสียชีวิตและผู้บาดเจ็บมีแนวโน้มลดลง กล่าวคือ ในปี พ.ศ. 2559\n  มีจำนวนครั้งของการเกิดอุบัติเหตุ 84,552 ครั้ง เพิ่มขึ้นจาก พ.ศ. 2558 ร้อยละ 21.88\n  โดยมีผู้เสียชีวิตถึง 8,409 คน เพิ่มขึ้นจาก พ.ศ. 2558 ร้อยละ 34.15 ผู้บาดเจ็บ 7,483 คน\n  ลดลงจากปีก่อน ร้อยละ 58.79\n</p>\n<p>\n  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; สำหรับยานพาหนะที่เกิดอุบัติสูงสุด 3\n  อันดับแรก ได้แก่ รถจักรยานยนต์ (ร้อยละ 36.96) รถยนต์นั่ง (ร้อยละ 29.13)\n  และรถบรรทุกขนาดเล็กหรือรถกระบะปิคอัพ (ร้อยละ 17.85)\n  มูลเหตุสันนิษฐานหลักที่ทำให้เกิดอุบัติเหตุ ได้แก่ ขับรถเร็ว (ร้อยละ 15.22)\n  คนหรือรถตัดหน้ากระชั้นชิด (ร้อยละ 15.14) ขับรถตามกระชั้นชิด (ร้อยละ 11.26)\n  อุปกรณ์ชำรุด (ร้อยละ 8.88) ขับรถผิดช่องทาง (ร้อยละ 5.58) ขับรถไม่ชำนาญ (ร้อยละ 5.39)\n  ไม่ยอดให้รถที่มีสิทธิ์ไปก่อน (ร้อยละ 4.61) เมาสุรา (ร้อยละ 1.40)\n</p>\n<p>\n  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; จากสถานการณ์ข้างต้น\n  แสดงให้เห็นว่าปัญหาอุบัติทางถนนเป็นปัญหาสำคัญที่ส่งผลต่อความสูญเสียทั้งทรัพยากรมนุษย์และมูลค่าความเสียหายมหาศาล\n  ดังนั้นการส่งเสริมการป้องกันอุบัติเหตุทางถนนในระดับชุมชนถือเป็นการแก้ไขปัญหาในระดับพื้นที่ที่จะส่งผลต่อการแก้ปัญหาในระดับประเทศได้\n</p>',
//   footer:
//     '<p>\n  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;ด้วยเหตุนี้ทางหมู่บ้าน/ชุมชน <b>{village}</b> ตำบล\n  <b>{subDistrict}</b> อำเภอ <b>{district}</b> จังหวัด <b>{province}</b>\n   ตระหนักถึงความสำคัญของกระบวนการส่งเสริมความปลอดภัยทางถนน\n  โดยใช้กระบวนการมีส่วนร่วมของชุมชนในมิติของการเรียนรู้ร่วมกันในการสร้างความตระหนักและเข้าใจด้านความปลอดภัยทางถนน\n  แล้วจึงสามารถระบุจุดและสร้างแผนที่เสี่ยงอุบัติเหตุทางถนน ซึ่งทำ\n  ให้สามารถทราบถึงสภาพปัญหาอุบัติเหตุทางถนนในปัจจุบันของชุมชน\n  อันนำมาสู่ขั้นตอนของการร่วมกันหาแนวทางในการปรับปรุงความปลอดภัยทางถนนของชุมชนต่อไป\n</p>',
//   villageInfo: {
//     village: 'เวียงหมอก',
//     subDistrict: 'ห้วยซ้อ',
//     district: 'เชียงของ',
//     province: 'เชียงราย',
//   },
//   accidentProblem: {
//     label: 'สถานการณ์ปัญหาการเกิดอุบัติเหตุทางถนนในชุมชน/หมู่บ้าน',
//     type: 'info',
//     message:
//       'ให้อธิบายรายละเอียดการวิเคราะห์สภาพปัญหาและผลกระทบที่เกิดจากจุดเสี่ยงที่ชัดเจน ว่าสาเหตุของปัญหาอุบัติเหตุที่เกิดจากจุดเสี่ยงแต่ละจุดคืออะไร',
//   },
//   communityInfo: {
//     name: 'communityInfo',
//     label:
//       '1. ข้อมูลพื้นฐานชุมชน (จำนวนประชากร ที่ตั้งของชุมชน ลักษณะพื้นที่ของชุมชน ลักษณะอาชีพ และความเป็นอยู่)',
//     value: '',
//     validators: [],
//   },
//   accidentProblemDetail: {
//     name: 'accidentProblemDetail',
//     label:
//       '2. รายละเอียดข้อมูลปัญหาอุบัติเหตุ จากจุดเสี่ยงที่เกิดขึ้นในชุมชน (ที่ไม่ใช่ถนนทางหลวงเส้นหลัก)',
//   },
//   accidentRiskPoint: {
//     name: 'accidentRiskPoint',
//     label: '(1) ท่านคิดว่ามีจุดเสี่ยงการเกิดอุบัติเหตุในหมู่บ้านของท่าน ',
//     postLabel: ' จุด',
//     value: '',
//     validators: [],
//   },
//   frequentAccidentsPointList: {
//     name: 'frequentAccidentsPointList',
//     label:
//       '(2) ท่านคิดว่าบริเวณที่ท่านเห็นว่าเป็นจุดเสี่ยงมีลักษณะอย่างไร พร้อมใส่ภาพประกอบเพื่อสามารถวิเคราะห์ จุดเสี่ยงได้ชัดเจน (ตอบได้มากกว่า 1 ข้อ)',
//     description: [
//       'ข้อมูลปัญหาอุบัติเหตุ สามารถหาแหล่งข้อมูลได้ที่ โรงพยาบาลส่งเสริมสุขภาพตำบล (รพ.สต.) สถานีตำรวจ และหน่วยกู้ภัยในพื้นที่',
//       'จุดเสี่ยงอันตรายที่เกิดขึ้นในชุมชน คือ ตำแหน่งที่เกิดอุบัติเหตุบ่อยครั้งบนถนนในชุมชน/หมู่บ้านที่มิใช่ทางหลวงเส้นหลัก และมีความสูญเสียจากอุบัติเหตุสูง เช่น ถนนเป็นหลุม เป็นบ่อ ทางโค้ง ทางร่วม ทางแยก ไม่มีแสงสว่าง ฯลฯ',
//     ],
//     value: [
//       {
//         id: '1',
//         accidentPoint: 9,
//         otherAccidentPoint: 'XX',
//         riskPoints: [
//           {
//             id: '1-1',
//             point: 'Test',
//             driverBehavior: [1, 0],
//             otherDriverBehavior: 'XXX',
//             numOfAccidents: 11,
//             died: 2,
//             diedMan: 2,
//             diedWomen: 0,
//             injured: 20,
//             injuredMan: 10,
//             injuredWomen: 10,
//             fixRiskPoint: 'Y',
//             environment: 'XXX',
//             fileName: 'post_02-640x640.jpg',
//             filePath: 'proposal/form6/accident/BD0DA75A-BE4A-4BD3-89CC-B9E0B34927E7.jpg',
//             fileUrl:
//               'http://103.91.191.229:9090/egranting/proposal/form6/accident/BD0DA75A-BE4A-4BD3-89CC-B9E0B34927E7.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=cana-access-key%2F20210529%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20210529T054621Z&X-Amz-Expires=604800&X-Amz-SignedHeaders=host&X-Amz-Signature=704fd31579fc119e7ba991689fed5c24820a7b9776c766f384f9367b4d7ea1d4',
//           },
//         ],
//       },
//       {
//         id: '2',
//         accidentPoint: 1,
//         otherAccidentPoint: '',
//         riskPoints: [
//           {
//             id: '2-1',
//             point: 'Test02',
//             driverBehavior: [1, 2],
//             otherDriverBehavior: '',
//             numOfAccidents: 20,
//             died: 2,
//             diedMan: 2,
//             diedWomen: 0,
//             injured: 20,
//             injuredMan: 10,
//             injuredWomen: 10,
//             fixRiskPoint: 'N',
//             environment: 'YYY',
//             fileName: 'post_02-640x640.jpg',
//             filePath: 'proposal/form6/accident/BD0DA75A-BE4A-4BD3-89CC-B9E0B34927E7.jpg',
//             fileUrl:
//               'http://103.91.191.229:9090/egranting/proposal/form6/accident/BD0DA75A-BE4A-4BD3-89CC-B9E0B34927E7.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=cana-access-key%2F20210529%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20210529T054621Z&X-Amz-Expires=604800&X-Amz-SignedHeaders=host&X-Amz-Signature=704fd31579fc119e7ba991689fed5c24820a7b9776c766f384f9367b4d7ea1d4',
//           },
//         ],
//       },
//     ],
//   },
//   accidentPoint: {
//     name: 'accidentPoint',
//     label: 'บริเวณจุดที่เกิดอุบัติเหตุบ่อย',
//     value: '',
//     options: [
//       {
//         id: '8852F348-34CA-46D1-A777-930AAE2DCB28',
//         name: 'AccidentLocation',
//         otherOption: false,
//         disabled: false,
//         label: 'ทางโค้ง',
//         value: 1,
//       },
//       {
//         id: '52EEB072-304F-4DA9-A3C0-A9F703FCDE0C',
//         name: 'AccidentLocation',
//         otherOption: false,
//         disabled: false,
//         label: 'ทางแยก',
//         value: 2,
//       },
//       {
//         id: '42FF9BF4-912E-4345-A93F-CDC44FED99FE',
//         name: 'AccidentLocation',
//         otherOption: false,
//         disabled: false,
//         label: 'หน้าตลาด/หน้าโรงเรียน',
//         value: 3,
//       },
//       {
//         id: 'EE4E53BE-3863-4292-8056-9ECF6C047947',
//         name: 'AccidentLocation',
//         otherOption: true,
//         disabled: false,
//         label: 'อื่นๆ',
//         value: 9,
//       },
//     ],
//     validators: [
//       {
//         type: 'REQUIRED',
//         value: null,
//         errorMessage: 'กรุณาเลือก บริเวณจุดที่เกิดอุบัติเหตุบ่อย',
//       },
//     ],
//   },
//   otherAccidentPoint: {
//     name: 'otherAccidentPoint',
//     label: 'โปรดระบุ',
//     hint: 'ระบุจุดที่เกิดอุบัติเหตุบ่อย',
//   },
//   riskPointSchema: {
//     point: {
//       name: 'point',
//       label: 'จุดที่',
//       hint: 'ลักษณะการเกิดเหตุ',
//       validators: [],
//     },
//     driverBehavior: {
//       name: 'driverBehavior',
//       label: 'พฤติกรรมของผู้ขับขี',
//       options: [
//         {
//           id: 'A2E78839-4068-42D9-9061-C56EC0770392',
//           name: 'DriverBehavior',
//           otherOption: false,
//           disabled: false,
//           label: 'ขับเร็ว',
//           value: 1,
//         },
//         {
//           id: '5676EA2A-63D5-41D0-B48A-EE05B6F935D4',
//           name: 'DriverBehavior',
//           otherOption: false,
//           disabled: false,
//           label: 'ไม่สวมหมวก',
//           value: 3,
//         },
//         {
//           id: '35F1C0F4-A049-44DE-B901-2D7AEC8409C4',
//           name: 'DriverBehavior',
//           otherOption: false,
//           disabled: false,
//           label: 'เมาแล้วขับ',
//           value: 4,
//         },
//         {
//           id: 'FAAB98D0-FF16-41D0-A9EE-2A929DAFBE67',
//           name: 'DriverBehavior',
//           otherOption: false,
//           disabled: false,
//           label: 'ซ้อนเกิน 2 คน',
//           value: 5,
//         },
//         {
//           id: '1818F571-E978-4978-8749-2714F961108A',
//           name: 'DriverBehavior',
//           otherOption: true,
//           disabled: false,
//           label: 'อื่น ๆ',
//           value: 9,
//         },
//       ],
//       validators: [],
//     },
//     otherDriverBehavior: {
//       name: 'otherDriverBehavior',
//       hint: 'โปรดระบุ...',
//       validators: [],
//     },
//     environment: {
//       name: 'environment',
//       label: 'สภาพแวดล้อม',
//       validators: [],
//     },
//     fixRiskPoint: {
//       name: 'fixRiskPoint',
//       label: 'โดยเป็นจุดเสี่ยงที่',
//       options: [
//         {
//           value: 'Y',
//           label: 'แก้ไขได้เอง',
//         },
//         {
//           value: 'N',
//           label: 'ส่งต่อหน่วยงานภายนอก',
//         },
//       ],
//       validators: [],
//     },
//     fixRiskPointDetail: {
//       name: 'fixRiskPointDetail',
//       label:
//         'อธิบายรายละเอียดวิธีแก้ไขจุดเสี่ยงที่ชุมชนแก้ไขได้เอง และพฤติกรรมเสี่ยงที่ทำให้เกิดอุบัติเหตุ ในแต่ละจุดให้ชัดเจน',
//       validators: [],
//     },
//     impact: {
//       label: 'ผลกระทบ (1 ปีที่ผ่านมา)',
//     },
//     numOfAccidents: {
//       name: 'numOfAccidents',
//       preLabel: '(1)จำนวนอุบัติเหตุ',
//       postLabel: 'ครั้ง',
//       validators: [],
//     },
//     died: {
//       name: 'died',
//       preLabel: '(2)เสียชีวิต',
//       postLabel: 'คน',
//       validators: [],
//     },
//     diedMan: {
//       name: 'diedMan',
//       preLabel: 'ชาย',
//       postLabel: 'คน',
//       validators: [],
//     },
//     diedWomen: {
//       name: 'diedWomen',
//       preLabel: 'หญิง',
//       postLabel: 'คน',
//       validators: [],
//     },
//     injured: {
//       name: 'injured',
//       preLabel: '(3) บาดเจ็บ',
//       postLabel: 'คน',
//     },
//     injuredMan: {
//       name: 'injuredMan',
//       preLabel: 'ชาย',
//       postLabel: 'คน',
//       validators: [],
//     },
//     injuredWomen: {
//       name: 'injuredWomen',
//       preLabel: 'หญิง',
//       postLabel: 'คน',
//       validators: [],
//     },
//     attachFiles: {
//       name: 'attachFiles',
//       label: 'แนบรูปจุดเสี่ยง',
//       value: '',
//       validators: [],
//     },
//   },
//   loss: {
//     name: 'loss',
//     label:
//       '(3) ความสูญเสียต่อชีวิตและทรัพย์สินที่เกิดขึ้นกับคนในชุมชน ที่เกิดจากอบุติเหตุบริเวณจุดเสี่ยงองชุมชนเป็นอย่างไร (โปรดอธิบาย)',
//     value: '',
//     validators: [],
//   },
// }
